var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"w-100"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-muted"},[_vm._v("HEX:")]),_vm._v(" "),_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(this.hexColor))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-muted"},[_vm._v("RGB:")]),_vm._v(" "),_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(this.bgColor))])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2af06c37","hasScoped":true,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/theme/ColorView.vue
// module id = null
// module chunks = 